module.exports = __webpack_public_path__ + "static/media/163192_16big.6090fbb5.jpg";